import { FC, useCallback, useContext, useMemo } from 'react';

import { formatTruckingCompany } from 'utils/format';
import { RedeliveryContext } from '../redelivery-context';

const RedeliveryDeleteTruckingCompany: FC<{ id: number }> = ({ id }) => {
  const { truckingCompanies, setTruckingCompanies } = useContext(RedeliveryContext);

  const truckingCompany = useMemo(() => truckingCompanies.get(id), [id, truckingCompanies]);
  const handleDelete = useCallback(
    () =>
      setTruckingCompanies(prevState => {
        const stateCopy = new Map(prevState);
        stateCopy.delete(id);
        return stateCopy;
      }),
    [id, setTruckingCompanies]
  );

  return (
    <div className="tag g-2 max-width-fit">
      <span className="text-primary">{formatTruckingCompany(truckingCompany)}</span>
      <button type="button" className="tag-close" onClick={handleDelete}>
        <span className="material-icons">close</span>
      </button>
    </div>
    // <div className="tag-close">
    //   <svg viewBox="0 0 24 24" onClick={handleDelete}>
    //     <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    //   </svg>
    // </div>
  );
};

export default RedeliveryDeleteTruckingCompany;
